/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CustomerAccountUpdateMutation(
    $customerAccountId: ID!,
    $displayName: String!,
    $enableLossProtection: Boolean
) {
  CustomerAccountUpdate(
    customerAccountId: $customerAccountId,
    displayName: $displayName,
    enableLossProtection: $enableLossProtection
  ) {
      id,
    message,
    status,
    Smpp {
      id
    }
  }
}
`
